import React, { useEffect, useState } from 'react'
import { useRef } from 'react';
import {
    FormGroup,
    FormControlLabel,
    Checkbox, Typography
} from "@mui/material";
import Grid from '@mui/material/Grid';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import { useNavigate, useLocation } from 'react-router-dom';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import axiosInstance from '../../../../lib/axios';
import CrudButtons from '../../../../GlobalFunction/CrudButtons';
import ReportTable from '../../../../atoms/ReportFolder/ReportTable';
import { useReactToPrint } from 'react-to-print';
import CustomAutocomplete from '../../../AutoComplete/AutoComplete';

const columns = [
    { id: 'RowNum', label: 'S.No.', minWidth: 170 },
    { id: 'VehicleName', label: 'Vehicle Name', minWidth: 100 },
    { id: 'VehTypeName', label: 'VehTypeName', minWidth: 100 },
    { id: 'Model', label: 'Model', minWidth: 100 },
    { id: 'FuelType', label: 'FuelType', minWidth: 100 },
    { id: 'VIN', label: 'VIN', minWidth: 100 },
];

const getTodayDate = () => {
    const today = new Date();
    return today.toISOString().split('T')[0]; // Returns YYYY-MM-DD
};
const initialFormState = {
    VehicleName: '',
    VehicleAbrv: '',
    VehTypeId: null,
    VehRegNo: '',
    VehRegDate: getTodayDate(),
    VehRegLstServDt: getTodayDate(),
    VehRegNxtServDueDt: getTodayDate(),
    VIN: '',
    Make: '',
    Model: '',
    YearOfMfg: new Date().getFullYear().toString(),
    Color: '',
    EngineNo: '',
    ChassisNo: '',
    FuelType: '',
    RCNo: '',
    RCExpDt: getTodayDate(),
    InsuranceExpDt: getTodayDate(),
    OdometerReading: '0.00',
    TaxExpDt: getTodayDate(),
    OwnerName: '',
    OwnerAddr: '',
    OwnerMobile: '',
    PUCExpDt: getTodayDate(),
    VehCapacity: '0',
    EngCapacity: '0',
    FitnessExpDt: getTodayDate(),
    PermitExpDt: getTodayDate(),
    CurrentOdometer: '0.00',
    IsOwnVeh: 'Y',
    GPSDeviceId: '',
    Remark: '',
    Status: '1'
};

const VehicleMst = () => {
    const [formData, setFormData] = useState(initialFormState);

    const [error, setError] = useState({
        VehicleName: false,

    });

    const navigate = useNavigate();
    const [isFormDisabled, setIsFormDisabled] = useState(true);
    const location = useLocation();
    const [currentVehicleId, setCurrentVehicleId] = useState(null);
    const [mode, setMode] = useState('view');
    const [Status, setStatus] = useState("1");
    const [lastInsertedVehicleId, setLastInsertedVehicleId] = useState(null);
    const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
    const [UserId, setUserId] = useState(sessionStorage.getItem('UserId'));
    const [DataForPrint, setDataForPrint] = useState({});
    const [rows, setRows] = useState([]);
    const [vehType, setVehType] = useState([]);
    const contentRef = useRef(null);
    const handlePrint = useReactToPrint({ contentRef });
    const VehicleNameRef = useRef(null);
    const remarkRef = useRef(null);
    const vehTypeNameRef = useRef(null);


    useEffect(() => {
        if (location.state && location.state.VehicleId) {
            setCurrentVehicleId(location.state.VehicleId);
            fetchVehicleMst(location.state.VehicleId);
            setMode('view');
        } else {
            setMode('add');
            setIsFormDisabled(false);
        }
    }, [location]);

    const resetForm = () => {
        setFormData({
            ...initialFormState,
            YearOfMfg: new Date().getFullYear().toString(),  // Always fresh current year
            VehRegDate: getTodayDate(),
            RCExpDt: getTodayDate(),
            InsuranceExpDt: getTodayDate(),
            TaxExpDt: getTodayDate(),
            FitnessExpDt: getTodayDate(),
            PermitExpDt: getTodayDate(),
        });
        setStatus("1");
        setCurrentVehicleId(null);
        setError({
            VehicleName: false,
            VehTypeId: false,
            Model: false,
            FuelType: false,
            VIN: false
        });
    };

    const fetchVehicleMst = async (id, flag) => {
        try {
            const response = await axiosInstance.post(`MstVehicle/RetriveMstVehicle`, {
                VehicleId: parseInt(id),
                Flag: flag
            });

            if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
                const vehicleData = response.data.Data[0];
                setFormData({
                    VehicleName: vehicleData.VehicleName || '',
                    VehicleAbrv: vehicleData.VehicleAbrv || '',
                    VehTypeId: vehicleData.VehTypeId || null,
                    VehRegNo: vehicleData.VehRegNo || '',
                    VehRegDate: vehicleData.VehRegDate ? vehicleData.VehRegDate.split('T')[0] : '',
                    VehRegLstServDt: vehicleData.VehRegLstServDt ? vehicleData.VehRegLstServDt.split('T')[0] : '',
                    VehRegNxtServDueDt: vehicleData.VehRegNxtServDueDt ? vehicleData.VehRegNxtServDueDt.split('T')[0] : '',
                    VIN: vehicleData.VIN || '',
                    Make: vehicleData.Make || '',
                    Model: vehicleData.Model || '',
                    YearOfMfg: vehicleData.YearOfMfg || '',
                    Color: vehicleData.Color || '',
                    EngineNo: vehicleData.EngineNo || '',
                    ChassisNo: vehicleData.ChassisNo || '',
                    FuelType: vehicleData.FuelType || '',
                    RCNo: vehicleData.RCNo || '',
                    RCExpDt: vehicleData.RCExpDt ? vehicleData.RCExpDt.split('T')[0] : '',
                    InsuranceExpDt: vehicleData.InsuranceExpDt ? vehicleData.InsuranceExpDt.split('T')[0] : '',
                    OdometerReading: vehicleData.OdometerReading || '0.00',
                    TaxExpDt: vehicleData.TaxExpDt ? vehicleData.TaxExpDt.split('T')[0] : '',
                    OwnerName: vehicleData.OwnerName || '',
                    OwnerAddr: vehicleData.OwnerAddr || '',
                    OwnerMobile: vehicleData.OwnerMobile || '',
                    PUCExpDt: vehicleData.PUCExpDt ? vehicleData.PUCExpDt.split('T')[0] : '',
                    VehCapacity: vehicleData.VehCapacity || '0',
                    EngCapacity: vehicleData.EngCapacity || '0',
                    FitnessExpDt: vehicleData.FitnessExpDt ? vehicleData.FitnessExpDt.split('T')[0] : '',
                    PermitExpDt: vehicleData.PermitExpDt ? vehicleData.PermitExpDt.split('T')[0] : '',
                    CurrentOdometer: vehicleData.CurrentOdometer || '0',
                    IsOwnVeh: vehicleData.IsOwnVeh || 'N',
                    GPSDeviceId: vehicleData.GPSDeviceId || '',
                    Remark: vehicleData.Remark,
                    Status: vehicleData.Status?.toString(),
                });
                setStatus(vehicleData.Status.toString() || "0");
                setIsFormDisabled(true);
                setCurrentVehicleId(vehicleData.VehicleId);
            }
        } catch (error) {
            toast.error('Error fetching Vehicle vehicleData. Please try again.');
        }
    };

    useEffect(() => {
        const getRow = async () => {
            try {
                const res = await axiosInstance.post('MstVehicle/GetMstVehicleDashBoard', {
                    "start": 1,
                    "PageSize": 1,
                    "SearchText": ""
                });
                if (res.data && res.data.Data) {
                    setRows(res.data.Data);
                    setDataForPrint(res.data.Data);
                }
            } catch (err) {
                toast.error('Error fetching data:', err);
            }
        };

        getRow();
    }, []);

    useEffect(() => {
        const fetchVehType = async () => {
            try {
                const response = await axiosInstance.post(`MstVehicle/GetdrpMstVehType`,
                    {
                        Flag: ""
                    }
                );
                if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
                    const transformed = response.data.Data.map(item => ({
                        Id: item.VehTypeId,
                        Name: item.VehTypeName
                    }));
                    setVehType(transformed);
                }
            } catch (error) {
                toast.error("Error fetching VehType. Please try again.");
            }
        };
        fetchVehType();
    }, []);

    const handlePrevious = async () => {
        if (currentVehicleId && currentVehicleId > 1) {
            await fetchVehicleMst(currentVehicleId, "P");
        }
    };

    const handleNext = async () => {
        if (currentVehicleId) {
            await fetchVehicleMst(currentVehicleId, "N");
        }
    };

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleChangeStatus = (event) => {
        const updatedStatus = event.target.checked ? "1" : "0";
        setStatus(updatedStatus);
    };

    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            if (event.target === VehicleNameRef.current) {
                vehTypeNameRef.current.focus();
            } else {
                remarkRef.current.focus();
            }
        }
    };



    const handleSubmit = async () => {
        const errors = {};

        if (!formData.VehicleName?.trim()) errors.VehicleName = true;
        if (!formData.VehTypeId) errors.VehTypeId = true;
        if (!formData.Model?.trim()) errors.Model = true;
        if (!formData.FuelType?.trim()) errors.FuelType = true;
        if (!formData.VIN?.trim()) errors.VIN = true;

        setError(prev => ({ ...prev, ...errors }));

        // Show Smart Toast Message (Exactly like WorkerType style)
        if (Object.keys(errors).length > 0) {
            const missing = [];

            if (errors.VehicleName) missing.push("Vehicle Name");
            if (errors.VehTypeId) missing.push("Vehicle Type");
            if (errors.Model) missing.push("Model");
            if (errors.FuelType) missing.push("Fuel Type");
            if (errors.VIN) missing.push("VIN");

            const message = missing.length === 1
                ? `${missing[0]} is required`
                : `Please fill in the required fields: ${missing.join(", ")}`;

            toast.error(message, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                style: { fontSize: "15px" }
            });

            // Auto-focus first missing field
            setTimeout(() => {
                const firstField = Object.keys(errors)[0];
                const input = document.getElementsByName(firstField)[0] ||
                    document.getElementById("vehType-autocomplete")?.querySelector("input");
                input?.focus();
                input?.scrollIntoView({ behavior: "smooth", block: "center" });
            }, 300);

            return;
        }

        const payload = {
            VehicleName: formData.VehicleName.trim(),
            VehicleAbrv: formData.VehicleAbrv.trim() || "",
            VehTypeId: formData.VehTypeId,
            VehRegNo: formData.VehRegNo.trim() || "",
            VehRegDate: formData.VehRegDate || "",
            VehRegLstServDt: formData.VehRegLstServDt || "",
            VehRegNxtServDueDt: formData.VehRegNxtServDueDt || "",
            VIN: formData.VIN?.trim() || "",
            Make: formData.Make?.trim() || "",
            Model: formData.Model?.trim() || "",
            YearOfMfg: formData.YearOfMfg ? parseInt(formData.YearOfMfg) : "",
            Color: formData.Color?.trim() || "",
            EngineNo: formData.EngineNo?.trim() || "",
            ChassisNo: formData.ChassisNo?.trim() || "",
            FuelType: formData.FuelType?.trim() || "",
            RCNo: formData.RCNo?.trim() || "",
            RCExpDt: formData.RCExpDt || "",
            InsuranceExpDt: formData.InsuranceExpDt || "",
            OdometerReading: formData.OdometerReading ? parseFloat(formData.OdometerReading) : "",
            TaxExpDt: formData.TaxExpDt || "",
            OwnerName: formData.OwnerName?.trim() || "",
            OwnerAddr: formData.OwnerAddr?.trim() || "",
            OwnerMobile: formData.OwnerMobile?.trim() || "",
            PUCExpDt: formData.PUCExpDt || "",
            VehCapacity: formData.VehCapacity ? parseInt(formData.VehCapacity) : "",
            EngCapacity: formData.EngCapacity ? parseFloat(formData.EngCapacity) : "",
            FitnessExpDt: formData.FitnessExpDt || "",
            PermitExpDt: formData.PermitExpDt || "",
            CurrentOdometer: formData.CurrentOdometer ? parseFloat(formData.CurrentOdometer) : "",
            IsOwnVeh: formData.IsOwnVeh || "N",
            GPSDeviceId: formData.GPSDeviceId?.trim() || "",
            Status: Status,                    // "1" or "0"
            Remark: formData.Remark?.trim() || ""
        };

        // Add CreatedBy / UpdatedBy
        if (mode === "add") {
            payload.CreatedBy = parseInt(UserId) || 1;
        } else if (mode === "edit") {
            payload.VehicleId = currentVehicleId;
            payload.UpdatedBy = parseInt(UserId) || 1;
        }

        try {
            let response;

            if (mode === "edit") {
                response = await axiosInstance.post("MstVehicle/UpdateMstVehicle", payload);
            } else {
                response = await axiosInstance.post("MstVehicle/InsertMstVehicle", payload);
            }

            if (response.data.Status === 0 && response.data.responseStatusCode === 1) {
                toast.success(response.data.Message || "Vehicle saved successfully!");

                const savedId = response.data.Data || currentVehicleId;
                setCurrentVehicleId(savedId);

                // Refresh form with fresh data
                await fetchVehicleMst(savedId);

                setMode("view");
                setIsFormDisabled(true);
            } else {
                toast.error(response.data.Message || "Save failed");
            }
        } catch (error) {
            console.error("Save error:", error);
        }
    };

    const handleEdit = async () => {
        setMode("edit");
        setIsFormDisabled(false);
    };

    const handleAdd = () => {
        setMode('add');
        setIsFormDisabled(false);
        resetForm();

        setTimeout(() => {
            VehicleNameRef.current.focus();
        }, 0);
    };

    const handleCancel = async () => {
        if (mode === "add") {
            await fetchVehicleMst(1, "L");
        } else {

            await fetchVehicleMst(currentVehicleId, "R");
        }
        setMode("view");
        setIsFormDisabled(true);
    };

    const handleExit = () => {
        navigate('/vehicle-table');
    }

    const handleDeleteClick = () => {
        setOpenConfirmDialog(true);
    };

    const handleCloseConfirmDialog = () => {
        setOpenConfirmDialog(false);
    };

    const handleConfirmDelete = async () => {
        try {
            setOpenConfirmDialog(false);
            const response = await axiosInstance.post("MstVehicle/DeleteMstVehicle", {
                VehicleId: currentVehicleId
            });

            if (response.data.Status === 0) {
                toast.success(response.data.Message || 'Record Deleted.');
                await fetchVehicleMst(currentVehicleId, "P");
                setStatus("1");
                setMode('view');
                setIsFormDisabled(true);
            } else {
                toast.warn(response.data.Message || 'Failed to delete the record.');
            }
        } catch (error) {
            console.error("Error deleting record: ", error);
        }
    };
    return (
        <>
            <Box className="form-container" sx={{ height: { xs: '700px', sm: '550px' } }}>
                <ToastContainer />
                <Grid container spacing={2} className='form_grid'>
                    <Grid item xs={12} className='form_title'
                        sx={{
                            display: 'flex', alignItems: 'center',
                            justifyContent: 'space-between', marginTop: '20px',
                            flexDirection: { xs: 'column', sm: 'row', md: 'row' }
                        }}
                    >
                        <Grid
                            sx={{
                                display: 'flex',
                                justifyContent: { xs: 'center', sm: 'flex-start' },
                                marginBottom: { xs: '10px', sm: 0 }
                            }}
                        >
                            <Button
                                variant="contained"
                                size="small"
                                className='three-d-button-previous'
                                onClick={handlePrevious}
                                sx={{ backgroundColor: '#635BFF', marginRight: { xs: '5px', sm: '10px' }, display: 'block' }}
                                disabled={mode !== 'view' || !currentVehicleId || currentVehicleId === 1}
                            >
                                <KeyboardArrowLeftIcon />
                            </Button>

                            <Button
                                variant="contained"
                                size="small"
                                // sx={{ margin: '0px 10px' }}
                                className='three-d-button-next'
                                onClick={handleNext}
                                sx={{ backgroundColor: '#635BFF', display: 'block' }}
                                disabled={mode !== 'view' || !currentVehicleId}
                            >
                                <NavigateNextIcon />
                            </Button>
                        </Grid>

                        <Typography
                            variant="h5"
                            sx={{
                                margin: 'Auto',
                                textAlign: { xs: 'center', sm: 'center' },
                                fontSize: { xs: '24px', sm: '18px', md: '24px' }
                            }}
                        >
                            Vehicle Master
                        </Typography>

                        <Grid sx={{ display: "flex", justifyContent: "end" }}>
                            <CrudButtons
                                moduleName={"Vehicle Type"}
                                mode={mode}
                                onAdd={handleAdd}
                                onEdit={handleEdit}
                                onView={handlePrint}
                                onDelete={handleDeleteClick}
                                onExit={handleExit}
                                onPrevious={handlePrevious}
                                onNext={handleNext}
                                readOnlyMode={isFormDisabled}
                            />
                        </Grid>
                    </Grid>

                    <Grid item xs={12} className='form_field'>
                        <Grid container spacing={1}>
                            <Grid item xs={12} md={3} lg={3}>
                                <TextField
                                    id="VehicleName"
                                    name="VehicleName"
                                    label={
                                        <span>
                                            Vehicle Name <span style={{ color: 'red' }}>*</span>
                                        </span>
                                    }
                                    variant="filled"
                                    fullWidth
                                    className="custom-textfield"
                                    value={formData.VehicleName}
                                    onChange={handleInputChange}
                                    disabled={isFormDisabled}
                                    helperText={error.VehicleName && ""}
                                    inputRef={VehicleNameRef}
                                    onKeyDown={handleKeyPress}
                                />
                            </Grid>

                            <Grid item xs={12} md={2} lg={2}>
                                <TextField
                                    id="VehicleAbrv"
                                    name="VehicleAbrv"
                                    label="VehicleAbrv"
                                    variant="filled"
                                    fullWidth
                                    className="custom-textfield"
                                    value={formData.VehicleAbrv}
                                    onChange={handleInputChange}
                                    disabled={isFormDisabled}
                                    inputRef={remarkRef}
                                />
                            </Grid>
                            <Grid item xs={12} md={4} lg={3}>
                                <CustomAutocomplete
                                    options={vehType}
                                    id="vehType-autocomplete"
                                    name="VehTypeId"
                                    label={<span>VehType<span style={{ color: 'red' }}>*</span></span>}
                                    value={vehType.find(vType => vType.Id === formData.VehTypeId) || ''}
                                    onChange={handleInputChange}
                                    disabled={isFormDisabled}
                                    className="custom-textfield"
                                    variant='filled'
                                    inputRef={vehTypeNameRef}
                                />
                            </Grid>
                            <Grid item xs={12} md={2}>
                                <TextField
                                    label={
                                        <span>
                                            Model <span style={{ color: 'red' }}>*</span>
                                        </span>
                                    }
                                    className="custom-textfield"
                                    fullWidth variant="filled"
                                    name="Model"
                                    value={formData.Model}
                                    onChange={handleInputChange}
                                    disabled={isFormDisabled}
                                />
                            </Grid>

                            <Grid item xs={12} md={2}>
                                <TextField
                                    label="Registration No *"
                                    className="custom-textfield"
                                    fullWidth
                                    variant="filled"
                                    name="VehRegNo"
                                    value={formData.VehRegNo}
                                    onChange={handleInputChange}
                                    disabled={isFormDisabled}
                                //   error={!!error.VehRegNo}
                                />
                            </Grid>
                            <Grid item xs={12} md={2}>
                                <TextField label="Registration Date" className="custom-textfield" type="date" fullWidth variant="filled" name="VehRegDate" value={formData.VehRegDate} onChange={handleInputChange} disabled={isFormDisabled} InputLabelProps={{ shrink: true }} />
                            </Grid>
                            <Grid item xs={12} md={2.5}>
                                <TextField
                                    label={
                                        <span>
                                            VIN <span style={{ color: 'red' }}>*</span>
                                        </span>
                                    }
                                    className="custom-textfield"
                                    fullWidth
                                    variant="filled"
                                    name="VIN"
                                    value={formData.VIN}
                                    onChange={handleInputChange}
                                    disabled={isFormDisabled}
                                />
                            </Grid>



                            <Grid item xs={12} md={2}>
                                <TextField label="Make" className="custom-textfield" fullWidth variant="filled" name="Make" value={formData.Make} onChange={handleInputChange} disabled={isFormDisabled} />
                            </Grid>

                            <Grid item xs={12} md={1}>
                                <TextField
                                    label="Year of Mf"
                                    className="custom-textfield"
                                    type="number"
                                    fullWidth
                                    variant="filled"
                                    name="YearOfMfg"
                                    value={formData.YearOfMfg}
                                    onChange={handleInputChange}
                                    disabled={isFormDisabled} />
                            </Grid>

                            <Grid item xs={12} md={1}>
                                <TextField
                                    label="Color"
                                    className="custom-textfield"
                                    fullWidth variant="filled"
                                    name="Color"
                                    value={formData.Color}
                                    onChange={handleInputChange}
                                    disabled={isFormDisabled}
                                />
                            </Grid>
                            <Grid item xs={12} md={1.5}>
                                <TextField
                                    label={
                                        <span>
                                            Fuel Type  <span style={{ color: 'red' }}>*</span>
                                        </span>
                                    } className="custom-textfield"
                                    fullWidth variant="filled"
                                    name="FuelType"
                                    value={formData.FuelType}
                                    onChange={handleInputChange}
                                    disabled={isFormDisabled} />
                            </Grid>

                            <Grid item xs={12} md={2}>
                                <TextField
                                    label="Engine No"
                                    className="custom-textfield"
                                    fullWidth
                                    variant="filled"
                                    name="EngineNo"
                                    value={formData.EngineNo}
                                    onChange={handleInputChange}
                                    disabled={isFormDisabled}
                                />
                            </Grid>
                            <Grid item xs={12} md={2}>
                                <TextField
                                    label="Chassis No"
                                    className="custom-textfield"
                                    fullWidth
                                    variant="filled"
                                    name="ChassisNo"
                                    value={formData.ChassisNo}
                                    onChange={handleInputChange}
                                    disabled={isFormDisabled}
                                />
                            </Grid>

                            <Grid item xs={12} md={2}>
                                <TextField
                                    label="RC Number" className="custom-textfield" fullWidth variant="filled" name="RCNo" value={formData.RCNo} onChange={handleInputChange} disabled={isFormDisabled} />
                            </Grid>
                            <Grid item xs={12} md={2}>
                                <TextField
                                    label="RC Expiry"
                                    className="custom-textfield"
                                    type="date"
                                    fullWidth
                                    variant="filled"
                                    name="RCExpDt"
                                    value={formData.RCExpDt}
                                    onChange={handleInputChange}
                                    disabled={isFormDisabled}
                                    InputLabelProps={{ shrink: true }} />
                            </Grid>
                            <Grid item xs={12} md={2}>
                                <TextField
                                    label="PUCExpDt"
                                    className="custom-textfield"
                                    type="date"
                                    fullWidth
                                    variant="filled"
                                    name="PUCExpDt"
                                    value={formData.PUCExpDt}
                                    onChange={handleInputChange}
                                    disabled={isFormDisabled}
                                    InputLabelProps={{ shrink: true }} />
                            </Grid>
                            <Grid item xs={12} md={2}>
                                <TextField
                                    label="Insurance Expiry"
                                    className="custom-textfield"
                                    type="date"
                                    fullWidth
                                    variant="filled"
                                    name="InsuranceExpDt"
                                    value={formData.InsuranceExpDt}
                                    onChange={handleInputChange}
                                    disabled={isFormDisabled}
                                    InputLabelProps={{ shrink: true }} />
                            </Grid>

                            <Grid item xs={12} md={2}>
                                <TextField label="VehRegLastServDt" className="custom-textfield" type="date" fullWidth variant="filled" name="VehRegLstServDt" value={formData.VehRegLstServDt} onChange={handleInputChange} disabled={isFormDisabled} InputLabelProps={{ shrink: true }} />
                            </Grid>
                            <Grid item xs={12} md={2}>
                                <TextField label="VehRegNxtServDueDt" className="custom-textfield" type="date" fullWidth variant="filled" name="VehRegNxtServDueDt" value={formData.VehRegNxtServDueDt} onChange={handleInputChange} disabled={isFormDisabled} InputLabelProps={{ shrink: true }} />
                            </Grid>

                            <Grid item xs={12} md={3}>
                                <TextField
                                    label="Owner Name"
                                    className="custom-textfield"
                                    fullWidth
                                    variant="filled"
                                    name="OwnerName"
                                    value={formData.OwnerName}
                                    onChange={handleInputChange}
                                    disabled={isFormDisabled} />
                            </Grid>
                            <Grid item xs={12} md={1.6}>
                                <TextField
                                    label="Owner Mobile"
                                    type="number"
                                    className="custom-textfield"
                                    fullWidth
                                    variant="filled"
                                    name="OwnerMobile"
                                    value={formData.OwnerMobile}
                                    onChange={handleInputChange}
                                    disabled={isFormDisabled} />
                            </Grid>

                            <Grid item xs={6} md={5.4}>
                                <TextField
                                    label="Owner Address"
                                    className="custom-textfield"
                                    fullWidth
                                    variant="filled"
                                    name="OwnerAddr"
                                    value={formData.OwnerAddr}
                                    onChange={handleInputChange}
                                    disabled={isFormDisabled} />
                            </Grid>

                            <Grid item xs={12} md={2}>
                                <TextField
                                    className="custom-textfield"
                                    label="Odometer Reading"
                                    type="number"
                                    fullWidth
                                    variant="filled"
                                    name="OdometerReading"
                                    value={formData.OdometerReading}
                                    onChange={handleInputChange}
                                    disabled={isFormDisabled} />
                            </Grid>
                            <Grid item xs={12} md={1.5}>
                                <TextField
                                    className="custom-textfield"
                                    label="Current Odometer"
                                    type="number"
                                    fullWidth
                                    variant="filled"
                                    name="CurrentOdometer"
                                    value={formData.CurrentOdometer}
                                    onChange={handleInputChange}
                                    disabled={isFormDisabled} />
                            </Grid>
                            <Grid item xs={12} md={1.5}>
                                <TextField
                                    label="Veh Capacity (Seats)"
                                    className="custom-textfield"
                                    type="number"
                                    fullWidth
                                    variant="filled"
                                    name="VehCapacity"
                                    value={formData.VehCapacity}
                                    onChange={handleInputChange}
                                    disabled={isFormDisabled}
                                />
                            </Grid>
                            <Grid item xs={12} md={2}>
                                <TextField
                                    id="EngCapacity"
                                    name="EngCapacity"
                                    className="custom-textfield"
                                    label="Engine Capacity (cc)"
                                    type="number"
                                    step="0.1"
                                    fullWidth
                                    variant="filled"
                                    value={formData.EngCapacity}
                                    onChange={handleInputChange}
                                    disabled={isFormDisabled} />
                            </Grid>

                            <Grid item xs={12} md={1.6}>
                                <TextField
                                    id="TaxExpDt"
                                    name="TaxExpDt"
                                    label="Tax Expiry"
                                    type="date"
                                    fullWidth
                                    variant="filled"
                                    className="custom-textfield"
                                    value={formData.TaxExpDt}
                                    onChange={handleInputChange}
                                    disabled={isFormDisabled}
                                    InputLabelProps={{ shrink: true }}
                                />
                            </Grid>
                            <Grid item xs={12} md={1.7}>
                                <TextField
                                    id="FitnessExpDt"
                                    label="Fitness Expiry"
                                    type="date"
                                    fullWidth
                                    variant="filled"
                                    name="FitnessExpDt"
                                    className="custom-textfield"
                                    value={formData.FitnessExpDt}
                                    onChange={handleInputChange}
                                    disabled={isFormDisabled}
                                    InputLabelProps={{ shrink: true }} />
                            </Grid>
                            <Grid item xs={12} md={1.7}>
                                <TextField
                                    id="PermitExpDt"
                                    name="PermitExpDt"
                                    label="Permit Expiry"
                                    type="date"
                                    fullWidth
                                    variant="filled"
                                    className="custom-textfield"
                                    value={formData.PermitExpDt}
                                    onChange={handleInputChange}
                                    disabled={isFormDisabled}
                                    InputLabelProps={{ shrink: true }} />
                            </Grid>

                            <Grid item xs={12} md={2}>
                                <TextField
                                    id="GPSDeviceId"
                                    name="GPSDeviceId"
                                    label="GPS Device ID"
                                    fullWidth
                                    variant="filled"
                                    className="custom-textfield"
                                    value={formData.GPSDeviceId}
                                    onChange={handleInputChange}
                                    disabled={isFormDisabled}
                                />
                            </Grid>
                            <Grid item xs={12} md={2}>
                                <FormGroup>
                                    <FormControlLabel
                                        control={<Checkbox checked={formData.IsOwnVeh === 'Y'} onChange={(e) => setFormData(prev => ({ ...prev, IsOwnVeh: e.target.checked ? 'Y' : 'N' }))} disabled={isFormDisabled} />}
                                        label="Own Vehicle?"
                                    />
                                </FormGroup>
                            </Grid>


                            <Grid item xs={12} md={6} lg={6}>
                                <TextField
                                    id="Remark"
                                    name="Remark"
                                    label="Remark"
                                    variant="filled"
                                    fullWidth
                                    className="custom-textfield"
                                    value={formData.Remark}
                                    onChange={handleInputChange}
                                    disabled={isFormDisabled}
                                    inputRef={remarkRef}
                                />
                            </Grid>
                            <Grid item xs={12} md={6} lg={1}>
                                <FormGroup>
                                    <FormControlLabel
                                        control={
                                            <Checkbox
                                                disabled={isFormDisabled}
                                                checked={Status === "1"}
                                                onChange={handleChangeStatus}
                                            />
                                        }
                                        label="Status"
                                    />
                                </FormGroup>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs={12} className="form_button">
                        {mode === 'view' && (
                            <>
                                <Button variant="contained" sx={{ mr: 1, background: 'linear-gradient(290deg, #d4d4d4, #ffffff)' }} onClick={handleAdd} disabled>
                                    Submit
                                </Button>
                                <Button variant="contained" sx={{ mr: 1, background: 'linear-gradient(290deg, #a7c5e9, #ffffff)' }} onClick={handleEdit}
                                    disabled
                                >
                                    Cancel
                                </Button>
                            </>
                        )}
                        {(mode === 'edit' || mode === 'add') && (
                            <>
                                <Button variant="contained" sx={{ mr: 1 }} onClick={handleSubmit}>
                                    Submit
                                </Button>
                                <Button variant="contained" sx={{ mr: 1 }} onClick={handleCancel}>
                                    Cancel
                                </Button>

                            </>
                        )}
                    </Grid>
                </Grid>
            </Box>

            <div style={{ display: 'none' }}>
                {Object.keys(DataForPrint).length > 0 && <ReportTable
                    columns={columns}
                    rows={rows}
                    title="Vehicle Master"
                    contentRef={contentRef}
                    customStyles={{ backgroundColor: '#f5f5f5' }}
                />
                }
            </div>

            <Dialog
                open={openConfirmDialog}
                onClose={handleCloseConfirmDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">
                    {"Confirm Deletion"}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Are you sure you want to delete this record?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button
                        sx={{
                            backgroundColor: '#635bff',
                            color: 'white',
                            '&:hover': {
                                backgroundColor: '#1565c0',
                                color: 'white'
                            }
                        }}
                        onClick={handleConfirmDelete}
                    >
                        Yes
                    </Button>
                    <Button
                        sx={{
                            backgroundColor: '#635bff',
                            color: 'white',
                            '&:hover': {
                                backgroundColor: '#1565c0',
                                color: 'white'
                            }
                        }}
                        onClick={handleCloseConfirmDialog}
                    >
                        No
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default VehicleMst;